var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755748837637,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7095,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m-55.253333 257.493333a78.08 78.08 0 0 1 133.333333 55.253334 78.08 78.08 0 0 1-156.16 0 78.933333 78.933333 0 0 1 22.826667-55.253334z m267.306666 130.346667l-97.92 97.92a34.56 34.56 0 0 0-10.026666 24.533333v270.293334a8.746667 8.746667 0 0 1-8.746667 8.746666h-69.333333a8.746667 8.746667 0 0 1-8.746667-8.746666v-147.2h-34.56v147.2a8.746667 8.746667 0 0 1-8.746667 8.746666h-69.333333a8.746667 8.746667 0 0 1-8.746667-8.746666V510.08a35.2 35.2 0 0 0-10.026666-24.533333l-97.92-97.706667a43.733333 43.733333 0 0 1 0-61.226667 42.666667 42.666667 0 0 1 61.653333 0l76.586667 76.8a17.706667 17.706667 0 0 0 12.373333 4.906667h124.16a17.28 17.28 0 0 0 12.16-4.906667l76.8-76.8a42.666667 42.666667 0 0 1 61.653333 0 43.733333 43.733333 0 0 1-1.28 61.226667z",
    fill: "#FEC268",
    "p-id": 7096
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderage);
export default __webpack_public_path__ + "static/media/underage.b0db1547.svg";
export { ForwardRef as ReactComponent };